var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 109,
    viewBox: "0 0 110 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0006 0L57.8824 8.86836H67.2065L59.6627 14.3492L62.5444 23.2175L55.0006 17.7364L47.4565 23.2175L50.3382 14.3492L42.7944 8.86836H52.1189L55.0006 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6935 15.867L25.0025 20.1L31.5958 13.5071L30.1367 22.7165L38.4453 26.9499L29.2356 28.4087L27.7768 37.6188L23.5434 29.3101L14.334 30.7693L20.9273 24.176L16.6935 15.867Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.82666 54.1739L9.69502 51.2921V41.9677L15.1755 49.5118L24.0442 46.6301L18.5627 54.1739L24.0442 61.7177L15.1755 58.8363L9.69502 66.3801V57.0556L0.82666 54.1739Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6935 92.4807L20.9269 84.1717L14.334 77.5784L23.5438 79.0379L27.7765 70.7292L29.2356 79.939L38.445 81.3978L30.1374 85.6312L31.5958 94.8406L25.0025 88.2473L16.6935 92.4807Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0006 108.348L52.1186 99.4794H42.7944L50.3386 93.9986L47.4565 85.131L55.0006 90.6114L62.5444 85.131L59.6627 93.9986L67.2065 99.4794H57.882L55.0006 108.348Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3073 92.4807L84.9986 88.2477L78.405 94.8409L79.8641 85.6308L71.5562 81.3978L80.7656 79.939L82.2243 70.7292L86.4574 79.0379L95.6668 77.5784L89.0735 84.1724L93.3073 92.4807Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.174 54.1739L100.305 57.0556V66.3801L94.8247 58.8359L85.957 61.7177L91.4378 54.1739L85.957 46.6301L94.825 49.5118L100.305 41.9677V51.2925L109.174 54.1739Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3073 15.867L89.0739 24.176L95.6672 30.7693L86.457 29.3098L82.2243 37.6185L80.7656 28.4087L71.5562 26.9496L79.8641 22.7165L78.405 13.5074L84.999 20.1004L93.3073 15.867Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.8e29f2c3.svg";
export { ForwardRef as ReactComponent };